import { useContext } from "react";
import { useState, useEffect } from "react";
import { createContext } from "react";

export const MyErrorContext = createContext();

export default function ErrorContext({ children }) {
  const [errorStatus, setErrorStatus] = useState(false);
  const [errormessage,setErrormessage] =useState(null)
 

  return (
    <MyErrorContext.Provider
      value={{
        errorStatus,
        setErrorStatus,
        errormessage,setErrormessage
        
      }}
    >
      {children}
    </MyErrorContext.Provider>
  );
}

export const useError = () => {
  return useContext(MyErrorContext);
};
